import React from 'react';
import { Typography, Layout, Button, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import HubSpotForms from './HubSpotForms';
import './forStatic.css';
import './SupportPage.css';
import ChannelTalkService from '../../services/ChannelService';

const { Title, Paragraph } = Typography;
const { Header, Content } = Layout;

const SupportPage = ({ isAuthenticated }) => {
  // ページ表示時のイベントトラッキング
  React.useEffect(() => {
    ChannelTalkService.trackEvent('support_page_viewed', {
      is_authenticated: isAuthenticated,
      page_type: 'support',
    });
  }, [isAuthenticated]);
  const renderHeader = () => (
    <Header
      style={{
        background: '#fff',
        padding: '0 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <div style={{ flex: 1 }}></div>
      <div
        className="logo mobile-logo"
        style={{ textAlign: 'center', flex: 1 }}
      >
        <span>Ignite creativity with..</span>magicss
      </div>
      <div style={{ flex: 1, textAlign: 'right' }}>
        {!isAuthenticated && (
          <Button type="primary">
            <Link to="/login">無料登録</Link>
          </Button>
        )}
      </div>
    </Header>
  );

  return (
    <>
      <Helmet>
        <title>法人様向け伴走サポート | magicss</title>
        <meta name="robots" content="noindex" />
        <meta
          property="og:title"
          content={`法人様向け伴走サポート | magicss`}
        />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={window.location.href} />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/img/ogp.png`}
        />
        <meta
          property="og:description"
          content={`AIライティングエージェント「magicss」の法人様向け伴走サポートページです。`}
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Layout id="static_page">
        {renderHeader()}
        <Content className="static_inner">
          <Title level={1} className="support-title">
            無料オンラインミーティングの予約
          </Title>
          <Paragraph className="support-description">
            貴社に合ったmagicssのカスタマイズ・活用方法をご案内させていただきます。
            <br />
            <br />
            AI時代のSEOに関してお困りのことがありましたら、ぜひお気軽にご相談ください。
            <br />
            以下よりオンラインミーティングのご予約をお願いいたします。
            <br />
            <br />
            ※ご提供できる枠には限りがございます。お早めにお申し込みください。
          </Paragraph>
          <Divider />
          <HubSpotForms formType="meetings" />
        </Content>
      </Layout>
    </>
  );
};

export default SupportPage;
